import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {useAxiosPrivate} from "../useAxiosPrivate";

export default function useBillingcredentialQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const billingcredentialListQuery = useQuery({
        queryKey: ["billing-credentials"],
        queryFn: () =>
            axiosPrivate
                .get("billing-credentials/")
                .then(r => r.data),
    });

    const useBillingcredentialQuery = (id) =>
        useQuery({
            queryKey: ["billing-credentials", id],
            queryFn: () =>
                axiosPrivate
                    .get(`billing-credentials/${id}/`)
                    .then(r => r.data),
            enabled: !!id,
        });

    // MUTATIONS ------------------------------------------------------

    const useCreateBillingcredential = (onSuccess) =>
        useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("billing-credentials/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["billing-credentials"]);
                onSuccess && onSuccess(...args);
            },
        });

    const useUpdateBillingcredential = (onSuccess) =>
        useMutation({
            mutationFn: ({id, data}) =>
                axiosPrivate
                    .put(`billing-credentials/${id}/`, data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["billing-credentials"]);
                onSuccess && onSuccess(...args);
            },
        });

    const useDeleteBillingcredential = (onSuccess) =>
        useMutation({
            mutationFn: (id) =>
                axiosPrivate
                    .delete(`billing-credentials/${id}/`)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["billing-credentials"]);
                onSuccess && onSuccess(...args);
            },
        });

    const useBillingcredentialMakeActive = (onSuccess) =>
        useMutation({
            mutationFn: (id) =>
                axiosPrivate
                    .get(`billing-credentials/${id}/make_active/`)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["billing-credentials"]);
                onSuccess && onSuccess(...args);
            },
        });

    const useBillingcredentialDeactivate = (onSuccess) =>
        useMutation({
            mutationFn: (id) =>
                axiosPrivate
                    .get(`billing-credentials/${id}/deactivate/`)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["billing-credentials"]);
                onSuccess && onSuccess(...args);
            },
        });

    // RETURN HOOKS ------------------------------------------------------

    return {
        billingcredentialListQuery,
        useBillingcredentialQuery,

        useCreateBillingcredential,
        useUpdateBillingcredential,
        useDeleteBillingcredential,

        useBillingcredentialMakeActive,
        useBillingcredentialDeactivate,
    };
}
